// extracted by mini-css-extract-plugin
export default {"Icon":"TwitterButton_Icon__Rvszu"};